import { render, staticRenderFns } from "./BrandsManager.vue?vue&type=template&id=b19bda14&lang=pug"
import script from "./BrandsManager.vue?vue&type=script&lang=js"
export * from "./BrandsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports